// extracted by mini-css-extract-plugin
export default {"dateSwitch":"DateSwitch_dateSwitch__YyMWo","datePickerArea":"DateSwitch_datePickerArea__Qp-51","switchBtn":"DateSwitch_switchBtn__u90PJ","label":"DateSwitch_label__ftTrb"};